import React from 'react'

const Project = ({ image, link, tech }) => (
  <div className="col-lg-6  appCard ">
    <div className="cardWrapper text-center">
      <img className="img-fluid cardImage " src={image} />
      <h4 className="projCaption">
        {tech.map(
          (eachTech, i) =>
            i < tech.length - 1 ? `${eachTech} | ` : `${eachTech} `
        )}
      </h4>
      <div>
        <a href={link}>
          <button className="btn btn-primary btn-md ">Preview App</button>
        </a>
      </div>
    </div>
  </div>
)

export default Project



// WEBPACK FOOTER //
// ./src/components/Project.js